//
import { font, color, breakpoints } from "./variables"

export const typography = `
  h1, .h1 { font-size: ${font.size.headingMobile[0]}; }
  h2, .h2 { font-size: ${font.size.headingMobile[1]}; }
  h3, .h3 { font-size: ${font.size.headingMobile[2]}; }
  h4, .h4 { font-size: ${font.size.headingMobile[3]}; }
  h5, .h5 { font-size: ${font.size.headingMobile[4]}; }
  h6, .h6 { font-size: ${font.size.headingMobile[5]}; }

  h1, h2, .h1, .h2 {
    font-family: ${font.family.cursive};
    margin-bottom: 30px;
  }

  h3, h4, h5, h6, .h3, .h4, .h5, .h6 {
    font-family: ${font.family.sans};
    margin-bottom: 15px;
    font-weight: bold;
    color: ${color.rgb.black[0]};
  }

  h1, .h1 {
    color: ${color.rgb.purple[1]};
    line-height: 72px;
    letter-spacing: 0.15px;
  }

  h2, .h2 {
    line-height: 54px;
    letter-spacing: 0.15px;
    color: ${color.rgb.black[0]};
  }

  h3, .h3 {
    line-height: 33px;
    letter-spacing: 0.15px;
  }

  .h4, h4 {
    line-height: 28px;
    letter-spacing: 0.15px;
  }

  h5, .h5 {
    line-height: 24px;
  }

  h6, .h6 {
    line-height: 19px;
  }

  p, main {
    line-height: 25px;
  }

  .flexible-content-component {
    p + h1,
    p + h2,
    p + h3,
    p + h4,
    p + h5,
    p + h6 {
      margin-top: 30px;
    }
  }

  .text-sm { font-size: ${font.size.main[0]}}
  .text-lg { font-size: ${font.size.main[2]}}

  @media (min-width: ${breakpoints.md}px) {
    h1, .h1 { font-size: ${font.size.heading[0]}; }
    h2, .h2 { font-size: ${font.size.heading[1]}; }
    h3, .h3 { font-size: ${font.size.heading[2]}; }
    h4, .h4, .title + .subtitle { font-size: ${font.size.heading[3]}; }
    h5, .h5 { font-size: ${font.size.heading[4]}; }
    h6, .h6 { font-size: ${font.size.heading[5]}; }

    .h1-large { font-size: 72px; }
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/typography.js